// Small, defensive parsers used by the Consequence Details dialogs.
// The underlying fields (miss_history, makeup_dates, intervention_notes, etc.)
// may be JSON strings, already-parsed arrays, null/undefined, or malformed —
// we normalize all cases so the dialog never crashes on render.

import { format, isValid } from "date-fns";

/**
 * parseArrayField(value)
 *  - undefined / null / empty string  -> []
 *  - already an array                 -> that array
 *  - JSON string encoding an array    -> parsed array
 *  - anything else / parse error      -> []
 * Never throws.
 */
export const parseArrayField = (value) => {
  if (value === undefined || value === null || value === "") return [];
  if (Array.isArray(value)) return value;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

/**
 * safeFormatDate(value, fmt, fallback)
 *  Attempts to `format(new Date(value), fmt)`. Returns `fallback` (default '—')
 *  if the value is missing, invalid, or the format throws.
 */
export const safeFormatDate = (value, fmt = "MMM d, yyyy", fallback = "—") => {
  if (value === undefined || value === null || value === "") return fallback;
  try {
    const d = value instanceof Date ? value : new Date(value);
    if (!isValid(d)) return fallback;
    return format(d, fmt);
  } catch {
    return fallback;
  }
};
